import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-termscondition',
  templateUrl: './termscondition.component.html',
  styleUrls: ['./termscondition.component.scss']
})
export class TermsconditionComponent implements OnInit {
  private isgraybackground:boolean=false;
  constructor() { }

  ngOnInit() {
    if(localStorage.getItem("PrimaryColor") && localStorage.getItem("SecondaryColor"))
    {
      //this.isFromDns=localStorage.getItem("isfromDns")
      this.isgraybackground=true;
    }
  }

}
